import { render } from "./CaseCalendar.vue?vue&type=template&id=560924d9&scoped=true&ts=true"
import script from "./CaseCalendar.vue?vue&type=script&lang=ts"
export * from "./CaseCalendar.vue?vue&type=script&lang=ts"

import "./CaseCalendar.vue?vue&type=style&index=0&id=560924d9&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560924d9"]])

export default __exports__